import { useAtomValue } from "jotai";
import { isEmpty, sortBy } from "lodash-es";
import type { ISO8601 } from "../../../utils/iso8601";
import type { UUID } from "../../../utils/uuid";
import { segmentStateAtom } from "../../moment/types/store";
import { useSegmentSaveAllowed } from "./use-segment-save-allowed";

type SegmentStateOption =
  | {
      id: UUID;
      name: string | null;
      description: string | null;
      deleted_at: ISO8601 | null;
      favorite_segment?:
        | {
            id: UUID;
          }
        | undefined
        | null;
    }
  | {
      id: UUID;
      name: string;
      group_id: null;
      description: null;
      favorite_segment: null;
    };

export function useSegmentStateOptions(): SegmentStateOption[] {
  const { data: segment_save_allowed } = useSegmentSaveAllowed();
  const segmentState = useAtomValue(segmentStateAtom);

  if (!segmentState) return [];

  const defaultOptionName = "New Segment";

  const options = segmentState.segments.map((segment) => {
    if (isEmpty(segment.name) || segment.name === "") {
      return { ...segment, name: "Ad Hoc Segment" };
    }

    return segment;
  });

  const defaultOption = segment_save_allowed
    ? [
        {
          id: segmentState.editable.new,
          name: defaultOptionName,
          group_id: null,
          description: null,
          favorite_segment: null,
        },
      ]
    : [];

  return sortBy(
    [
      ...defaultOption,
      ...options.sort((prevSegment, s) =>
        (prevSegment.name ?? "").localeCompare(s.name ?? "", undefined, {
          sensitivity: "base",
        }),
      ),
    ],
    (option) => [
      option.name === defaultOptionName ? 3 : option.favorite_segment ? 1 : 2,
      option.name,
    ],
  );
}
